<div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">
                <i class="fas fa-home"></i>
                Página Inicial</a>
            </li>
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" (click)="retornoAbaRisco()"> Riscos Chaves</a>
            </li>
            <li class="breadcrumb-item active"> {{titulo}} Riscos Chaves </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card-footer">
            <h3>Riscos</h3>
            <div class="subtitulo">
              <label>Unidade Auditada: </label><span> {{nomeUnidadeGestora}}</span><br>
              <label>SubTipo:</label><span> {{subtipo}}</span><br>
              <label>Macroprocesso: </label><span> {{macroprocesso}}</span><br>
              <label>Processo: </label><span> {{processo}}</span><br>
            </div>
  
            <mat-toolbar [hidden]="modoVisualizar" class="table-header">
              <mat-toolbar-row>
                <div class="btn-group">
                  <button class="btn btn-success btn-sm mr" (click)="buscarRisco()">
                    <i class="far fa-save"></i> Adicionar
                  </button>
                  <button type="button" class="btn btn-success btn-sm dropdown-toggle dropdown-icon"
                    data-toggle="dropdown" aria-expanded="false"></button>
                  <div class="dropdown-menu" role="menu">
                    <a class="dropdown-item" (click)="buscarRisco()">Risco Cadastrado</a>
                    <a class="dropdown-item" (click)="adicionarRiscoNaoCadastrado()">Risco Não Cadastrado</a>
                  </div>
                </div>
              </mat-toolbar-row>
            </mat-toolbar>
          </div>
  
          <div class="card-body">
            <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  
              Descrição do Risco
              <ng-container matColumnDef="descricao">
                <mat-header-cell *matHeaderCellDef> Descrição do Risco </mat-header-cell>
                <mat-cell *matCellDef="let risco"> {{risco.nomeRisco}}
  
                </mat-cell>
                <mat-footer-cell *matFooterCellDef> <strong>TOTAL</strong> </mat-footer-cell>
              </ng-container>
  
              <ng-container *ngFor="let escala of displayedColumnEscalas" [matColumnDef]="escala">
                <mat-header-cell *matHeaderCellDef>{{ escala }}</mat-header-cell>
                <mat-cell *matCellDef="let risco">
                  <mat-select [(value)]="risco[escala]" [disabled]="modoVisualizar"
                    (selectionChange)="selecionarItem(risco, escala, $event)">
                    <ng-container *ngFor="let esc of risco.escalasCriterioAvaliacao">
                      <ng-container *ngIf="esc.nome === escala">
                        <mat-option *ngFor="let mag of esc.magnitudeEscala" [value]="mag">
                          {{ mag.magnitude }}
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </mat-select>
                </mat-cell>
              </ng-container>
  
              <!-- RI -->
              <ng-container matColumnDef="ri">
                <mat-header-cell *matHeaderCellDef> RI </mat-header-cell>
                <mat-cell *matCellDef="let risco"> {{ risco.ri }} </mat-cell>
              </ng-container>
  
              <!-- Nível de Risco -->
              <ng-container matColumnDef="nivelRisco">
                <mat-header-cell *matHeaderCellDef> Nível de Risco </mat-header-cell>
                <mat-cell *matCellDef="let risco"> {{ risco.nivelRiscoRINome }} </mat-cell>
              </ng-container>
  
              <!-- Situação -->
              <ng-container matColumnDef="situacao">
                <mat-header-cell *matHeaderCellDef> Situação </mat-header-cell>
                <mat-cell *matCellDef="let risco">
                  <mat-select [(value)]="risco.situacaoSelecionada" [disabled]="modoVisualizar"
                    (selectionChange)="selecionarAvaliacao(risco, $event.value)">
                    <mat-option *ngFor="let controle of risco.riscoControle" [value]="controle.avaliacao">
                      {{controle.avaliacao}}
                    </mat-option>
                  </mat-select>
                </mat-cell>
              </ng-container>
  
              <!-- Risco de Controle -->
              <ng-container matColumnDef="riscoControle">
                <mat-header-cell *matHeaderCellDef> Risco de Controle </mat-header-cell>
                <mat-cell *matCellDef="let risco">
                  {{risco.avaliacaoSelecionada?.valorDoRisco || risco.riscoControleRR || 'N/A'}}
  
                </mat-cell>
              </ng-container>
  
              <!-- RR -->
              <ng-container matColumnDef="rr">
                <mat-header-cell *matHeaderCellDef> RR </mat-header-cell>
                <mat-cell *matCellDef="let risco"> {{ risco.rr }} </mat-cell>
              </ng-container>
  
              <!-- Nível de Risco Residual -->
              <ng-container matColumnDef="nivelRiscoResidual">
                <mat-header-cell *matHeaderCellDef> Nível de Risco </mat-header-cell>
                <mat-cell *matCellDef="let risco"> {{ risco.nivelRiscoRRNome }} </mat-cell>
              </ng-container>
  
              <!-- Ações -->
  
              <ng-container matColumnDef="acoes">
                <mat-header-cell *matHeaderCellDef [hidden]="modoVisualizar"> Ações </mat-header-cell>
                <mat-cell *matCellDef="let risco; let i = index" class="acoes-cell" [hidden]="modoVisualizar">
                  <button mat-icon-button color="warn" (click)="excluirRisco(risco.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button type="button" class="btn btn-success btn-sm mr" (click)="calcularRI(risco)">
                    <i class="far fa-add"></i><span>Calcular RI</span>
                  </button>
                  <button type="button" class="btn btn-success btn-sm mr" (click)="calcularRR(risco)">
                    <i class="far fa-add"></i><span>Calcular RR</span>
                  </button>
                </mat-cell>
              </ng-container>
  
              <!-- Cabeçalho e corpo da tabela -->
  
              <mat-header-row
                *matHeaderRowDef="displayedColumnDescricao.concat(displayedColumnEscalas).concat(displayedColumns)"></mat-header-row>
              <mat-row *matRowDef="let row; columns:
                 displayedColumnDescricao.concat(displayedColumnEscalas).concat(displayedColumns);"></mat-row>
  
            </mat-table>
          </div>
  
        </div>
      </div>
    </div>
  </div>
  
  
  <div class="card-footer">
  
    <mat-toolbar class="table-header">
      <mat-toolbar-row>
        <div class="btn-group">
          <button class="btn btn-primary btn-sm mr" (click)="salvarDados(false)" [hidden]="modoVisualizar">
            <i class="far fa-save"></i> Salvar
          </button>
          <button type="button" class="btn btn-primary btn-sm dropdown-toggle dropdown-icon" data-toggle="dropdown"
            aria-expanded="false" [hidden]="modoVisualizar"></button>
          <div class="dropdown-menu" role="menu">
            <a class="dropdown-item" (click)="salvarDados(false)">Salvar</a>
            <a class="dropdown-item" (click)="salvarDados(true)">Salvar e fechar</a>
          </div>
          <div class="flex-grow-1"> </div>
  
          <button type="button" style="height: fit-content;" class="btn btn-default btn-sm" (click)="onBack()">
            <i class="fas fa-times"></i> Fechar
          </button>
  
          <div class="ms-5" style="margin-left: 270px;"><strong>Magnitude {{valorTotalRI}}</strong></div>
          <div class="ms-5" style="margin-left: 445px;"><strong>Magnitude {{valorTotalRR}}</strong></div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
  